export default class SSEConstant {
  static OpCode = {
    Account: 1,     // 账户相关
    O2O: 2,      // 一对一call
    Push: 3,     // 推送，包括一对多
    Multi: 5,     // 语聊房
    Video: 6     // 直播间一对多
  };
  static OpPush = {
    addDiamond: 1,   //后台增加钻石
    anchorPutOnMic: 8,  // 主播上麦
    anchorPutOffMic: 12, // 主播下麦
    bossPutOnMic: 13,// 老板上麦
    bossPutOffMic: 14, // 老板下麦
    MultiRoomDestroy: 15, // 语聊房间解散
    hostBanAnchorMic: 16, // 主持人禁言主播
    hostUnbanAnchorMic: 17, // 主持人解禁主播
    hostEditRoom: 18, // 主持人编辑房间
    anchorOnMicTimeUp: 20, // 主播上麦300秒倒计时结束
    hostBanMemberText: 21, // 主持人禁止成员发文字消息
    hostForceAnchorPutOffMic: 22, // 主持人强制主播下麦
    receiveTextMsg: 23, // 收到文字消息
    perfectMatch: 24, // 配对成功
    roomMemberCountUpdated: 25, // 语聊房人数变化
    openVoiceChatRoom: 27, // 开启语聊房功能
    closeVoiceChatRoom: 28, // 关闭语聊房功能
    hostForceBossPutOffMic: 29, // 主持人强制boss下麦
    kickedOut: 30, // 被挤下线
    MultiRoomCreate: 32, // 新语聊房创建
    MultiRoomClose: 33,// 有语聊房关闭
    OpenVideoFeature: 34,// 开放视频聊天室功能【用来动态调整首页标签顺序】
    CloseVideoFeature: 35,// 关闭视频聊天室功能【用来动态调整首页标签顺序】
    VideoRoomClose: 36,// 老视频聊天室关闭
    VideoRoomCreate: 37,// 新视频聊天室开启
    VideoRoomResume: 38,// 视频聊天室恢复
    VideoRoomInfoUpdated: 39,// 视频聊天室信息更新
    VideoRoomDestroy: 40,// 视频聊天室解散
    VideoRoomPrivateChatFlagChange: 41, // 视频聊天室私聊开关改变
    VideoRoomHostIsTaken: 43, // 视频聊天室主持人被带走
    MultiOnMicTimeUpdate: 59, // 主播麦位倒计时改变
    VoiceChatRoomGoalUpdated: 60, // 语聊房目标数据更新
    VideoChatRoomGoalUpdated: 61, // 直播间目标数据更新
    VoiceChatRoomGoalDone: 62, // 语聊房目标数据更新
    VideoChatRoomGoalDone: 63,// 直播间目标数据更新
    VoiceHostWarnMember: 64, // 主持人警告成员消息
    VoiceChatRoomEnter: 79, // 语聊进入动画
    OpenWebPay: 77, // 语聊进入动画
    VideoRoomEnter: 80, // Live进入动画
  };

  static OpO2O = {
    userCall: 1,     // 用户呼叫,
    userStopCall: 3,
    receiveRefuse: 6,    // 用户收到主播拒接
    receiveAnchorEnter: 8,    // 用户收到主播进入房间
    receiveUserEnter: 27,   // 用户进入房间
    hungUp: 9,   // 挂电话
    callBilling: 14,  // 通话计费
    remindRecharge: 15,  // 通话时间不足，提醒充值
    receiveHunt: 22,    // 用户收到主播呼叫
    receiveStopHunt: 24,   // 用户收到主播停止呼叫
    remindHuntRecharge: 29,    // 主播主动呼叫的电话过程中提醒用户充值
  }

  /**
   * 语聊房操作相关返回码
   */
  static OpMulti = {
    joinRoom: 1     // 加入房间
    , leaveRoom: 2     // 离开房间
    , sendGift: 14    // 用户送礼
    , applyToBeBoss: 16    // 用户申请当boss
    , bossPutOffMic: 17    // 老板下麦
    , userTakeAnchor: 21    // 用户带走主播
    , bossBilling: 23    // 老板计费
    , remindBossToRecharge: 24    // 提醒老板充值
    , sendTextMsg: 27    // 发送文字消息
    , memberCloseMic: 28
    , memberOpenMic: 29
    , getRoomInfo: 30    // 获取房间信息
    , clientDisconnect: 31    // 掉线
  }
}




// WEBPACK FOOTER //
// ./src/push/const/SSEConstant.js